export default __webpack_public_path__ + "static/media/s2.91e5d4d3.jpg";